// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-equipment-codes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-equipment-codes/flight-plan-equipment-codes.js';

mount([g0]);
